<template>
  <section class="doubt">
    <span>{{ $t("helpers.chat.doubt_message") }}</span>

    <FAQ />
    {{ $t("helpers.chat.problem_not_listed") }}

    <section class="footer">
      <Back @changeComponent="setComponent" />
      <Contact @changeComponent="setComponent" />
    </section>
  </section>
</template>

<script>
import FAQ from "./Faq.vue";
import Back from "./Back.vue";
import Contact from "./Contact.vue";

export default {
  name: "HelpDoubtComponent",

  components: {
    FAQ,
    Back,
    Contact,
  },

  methods: {
    setComponent(component) {
      this.$emit("changeComponent", component);
    },
  },
};
</script>

<style lang="scss" scoped>
.doubt {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 12px;
  font-size: 14px;

  .footer {
    display: flex;
    align-items: center;
    gap: 6px;
    width: 100%;
  }
}
</style>
